/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Radio, InputAdornment, Button, Box, Grid, Tooltip } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { Autocomplete } from '@mui/material';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import SearchNotFound from '../../../SearchNotFound';
import { AddEditTable } from './AddEditTable';
import Delete from '@material-ui/icons/Delete';
import { AlertDialog } from './../../Common/AlertDialog';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "COLLECTORCROPUPDATE"

export default function CollectorCropUpdate(props) {

    const [dialogbox, setDialogbox] = useState(false);
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [farmer, setFarmer] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [cropForcaste, setCropForcaste] = useState([]);
    const [IsUpdate, setIsUpdate] = useState(true);
    const [IsClear, setIsClear] = useState(false);
    const [message, setMessage] = useState("Collector Crop Remove Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [cropForecastDetailID, setCropForecastDetailID] = useState(0);

    const navigate = useNavigate();
    const [isFarmerClear, setIsFarmerClear] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        farmerID: "0",
        cropCategoryID: "0",
        cropID: "0",
        cropName: '',
        date: new Date().toISOString().split('T')[0],
        isActive: true
    });

    const productcatogerySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center Required'),
        farmerID: isActive == true ? Yup.number().min(1, 'Please Select Collector').required('Collector Required') : Yup.number().notRequired(),
        cropCategoryID: isActive == false ? Yup.number().min(1, 'Please Select Crop Category').required('Crop Category Required') : Yup.number().notRequired(),
        cropID: isActive == false ? Yup.number().min(1, 'Please Select Crop').required('Crop Required') : Yup.number().notRequired(),
        date: Yup.date().required('Date Required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            farmerID: formData.farmerID,
            cropCategoryID: formData.cropCategoryID,
            cropID: formData.cropID,
            date: formData.date,
            isActive: formData.isActive
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCOLLECTORCROPUPDATE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }
    async function SubmitForm(value) {
        setCropForcaste([]);
        const res = await services.GetCollectorCropMappingDetailsByProductIDFarmerID(value.operationEntityID, isActive == false ? value.cropID : "0",
            isActive == true ? value.farmerID : "0", value.date)
        res.forEach(x => {
            let GivenName = x.farmerName == null ? "" : x.farmerName
            let Surname = x.surname == null ? "" : x.surname
            let Nic = x.nic == null ? "" : x.nic
            x.farmerName = GivenName + ' ' + Surname + ' - ' + Nic
            x.quantityBit = false
        })
        setCropForcaste(res)
    }

    const { errors, setErrors, setValues, touched, setTouched, handleSubmit, isSubmitting, getFieldProps, validateForm, values } = formik;

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetCollectorDetailsByFactoryIDRouteID());
        setCropForcaste([]);
        setValues({
            ...values,
            cropCategoryID: "0",
            cropID: "0"
        })
        setIsActive(true);
        setIsFarmerClear(!isFarmerClear);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setValues({
            ...values,
            farmerID: "0"
        })
        setIsClear(!IsClear);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setCropForcaste([]);
        setValues({
            ...values,
            cropCategoryID: "0",
            cropID: "0",
            farmerID: "0",
        });
        setIsClear(!IsClear);
        setIsFarmerClear(!isFarmerClear);
    }, [isActive]);

    useEffect(() => {
        if (dialogbox == false) {
            trackPromise(SubmitForm(values))
        }
    }, [dialogbox]);

    useEffect(() => {
        if (isActive == false) {
            if (product.length != 0) {
                const found = product.filter(x => x.productID == formik.values.cropID)
                setFormData((prevState) => ({
                    ...prevState,
                    cropName: found.length == 0 ? '' : found[0].productName,
                }));
            }
        }
        setCropForcaste([]);
    }, [formik.values.cropID]);

    useEffect(() => {
        setIsFarmerClear(!isFarmerClear);
        setCropForcaste([]);
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setCropForcaste([]);
    }, [formik.values.farmerID]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            setProductcatogery(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(formik.values.operationEntityID, formik.values.cropCategoryID)
        if (res != null) {
            setProduct(res);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            setFactory(res);
        }
    }

    async function GetCollectorDetailsByFactoryIDRouteID() {
        var res = await services.GetCollectorDetailsByFactoryIDRouteID(formik.values.operationEntityID)
        if (res != null) {
            res.forEach(x => {
                x.givenName = x.givenName == null || x.givenName == "" ? x.farmerCode : x.givenName
            })
            setFarmer(res);
        }
    }

    const handleRadioChange = (event) => {
        setIsActive(event.target.value);
        setCropForcaste([]);
    };

    function changeText(e, cropForecastDetailID) {
        setIsUpdate(true)
        const target = e.target;
        const value = target.value;
        const finalValue = value == "" ? parseFloat(0) : value
        var reg = new RegExp('^[0-9]{0,9}([.]?[0-9]{0,2})?$');

        if (reg.test(finalValue) == false) {
            toast.error("Allow Only Numbers");
            return;
        }
        const newArr = [...cropForcaste];
        if (finalValue == 0) {
            var idx = newArr.findIndex(e => e.cropForecastDetailID == parseInt(cropForecastDetailID));
            newArr[idx] = {
                ...newArr[idx], quantity: finalValue == "" ? parseFloat(0) : parseFloat(finalValue),
                quantityMsg: 'Quantity Required', quantityBit: true
            };
        }
        else {
            var idx = newArr.findIndex(e => e.cropForecastDetailID == parseInt(cropForecastDetailID));
            newArr[idx] = {
                ...newArr[idx], quantity: finalValue == "" ? parseFloat(0) : parseFloat(finalValue),
                quantityBit: false
            };
        }
        setCropForcaste(newArr)
    }

    async function handleSave() {
        trackPromise(SubmitForm(values))
        setDialogbox(true)
    }

    async function handleUpdate() {
        let newRes = _.cloneDeep(cropForcaste);
        const found = newRes.filter(x => x.quantityBit == true)
        if (found.length == 0) {
            let array = [];
            newRes.forEach(x => {
                array.push({
                    cropForecastDetailID: x.cropForecastDetailID,
                    quantity: x.quantity,
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken())
                })
            })
            let response = await services.UpdateCollectorCropForcasting(array);
            if (response.statusCode == "Success") {
                toast.success(response.message);
                trackPromise(SubmitForm(values))
            }
            else {
                toast.error(response.message);
                trackPromise(SubmitForm(values))
            }
        }
    }

    async function handleRemove(cropForecastDetailID) {
        let response = await services.RemoveCollectorCropForcasting(cropForecastDetailID, parseInt(TokenDecoder.getUserIDFromToken()));
        if (response.statusCode == "Success") {
            toast.success(response.message);
            trackPromise(SubmitForm(values))
        }
        else {
            toast.error(response.message);
            trackPromise(SubmitForm(values))
        }
    }

    function handleSearch(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                farmerID: '0'
            });
            return;
        } else {
            var valueV = data.farmerID;

            setValues({
                ...values,
                farmerID: valueV
            });
        }
    }

    function handleSearchCrop(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                cropID: 0
            });
            return;
        } else {
            var valueV = data["productID"];

            setValues({
                ...values,
                cropID: valueV
            });
        }
    }

    function clearAll() {
        setCropForcaste([]);
        setValues({
            ...values,
            cropCategoryID: "0",
            cropID: "0",
            farmerID: "0",
        });
        setIsActive(true);
        setIsClear(!IsClear);
        setIsFarmerClear(!isFarmerClear);
    }

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.givenName && option.givenName.toLowerCase().includes(trimmedInput)) ||
            (option.nic && option.nic.toLowerCase().startsWith(trimmedInput)) ||
            (option.farmerCode && option.farmerCode.toLowerCase().startsWith(trimmedInput))
        ).filter(option => option.givenName !== null && option.nic !== null && option.farmerCode !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.givenName.toLowerCase() === trimmedInput ||
                option.nic.toLowerCase() === trimmedInput ||
                option.farmerCode.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });

        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    async function collectorCropPopUp(data) {
        setEnableConfirmMessage(true);
        setCropForecastDetailID(data)
    }

    function confirmData(y) {
        if (y) {
            trackPromise(handleRemove(cropForecastDetailID));
        }
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Collector Crop Update |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/createCropForcast"}
                        btname="Add"
                        pageName="Collector Crop Update"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid item md={4} xs={12} >
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}> Select Group</MenuItem>
                                            {group.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12} >
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Fresh Collection Center *"
                                            value={formik.values.operationEntityID}
                                            onChange={formik.operationEntityID}

                                            {...getFieldProps('operationEntityID')}
                                            error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                            helperText={touched.operationEntityID && errors.operationEntityID}
                                            InputProps={{
                                                readOnly: !permissionList.isFactoryFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}> Select Fresh Collection Center</MenuItem>
                                            {factory.map((option) => (
                                                option.isActive == true && option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                    {option.factoryName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12} >
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    color="secondary"
                                                    checked={isActive == 1}
                                                    onChange={handleRadioChange}
                                                    value={1}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'true' }}
                                                />}
                                            label="Collector wise"
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    color="secondary"
                                                    checked={isActive == 0}
                                                    onChange={handleRadioChange}
                                                    value={0}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'false' }}
                                                />}
                                            label="Crop wise"
                                            labelPlacement="end"
                                        />
                                    </Grid>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>

                                    {isActive == true ?
                                        <>
                                            <Grid item md={4} xs={12} >
                                                <Autocomplete fullWidth
                                                    key={IsClear}
                                                    id="farmerID"
                                                    clearOnEscape
                                                    options={farmer}
                                                    filterOptions={filterOptions}
                                                    getOptionLabel={(option) => `${option.givenName} - ${option.nic}`}
                                                    onChange={(e, value) => handleSearch(value, e)}
                                                    renderOption={(props, option) => (
                                                        <li {...props}>
                                                            {`${option.givenName} - ${option.nic}`}
                                                        </li>
                                                    )}
                                                    renderInput={(params) =>
                                                        <TextField {...params}
                                                            variant="outlined"
                                                            name="farmerID"
                                                            label="Collector Preferred Name / NIC *"
                                                            size="small"
                                                            fullWidth
                                                            helperText={touched.farmerID && errors.farmerID}
                                                            error={Boolean(touched.farmerID && errors.farmerID)}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item md={4} xs={12} >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-start-adornment"
                                                    size="small"
                                                    name='date'
                                                    label="Date *"
                                                    type="Date"
                                                    onKeyDown={onKeyDown}
                                                    value={formik.values.date}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('date')}
                                                    error={Boolean(touched.date && errors.date)}
                                                    helperText={touched.date && errors.date}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start"></InputAdornment>
                                                    }}
                                                    inputProps={{
                                                        min: new Date().toISOString().split('T')[0],
                                                    }}
                                                >
                                                </TextField>
                                            </Grid>
                                        </>
                                        : null}
                                    {isActive == false ?
                                        <Grid item md={4} xs={12} >
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Crop Category *"
                                                value={formik.values.cropCategoryID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('cropCategoryID')}
                                                error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}
                                                helperText={touched.cropCategoryID && errors.cropCategoryID}
                                            >
                                                <MenuItem key={0} value={0}> Select Crop Category</MenuItem>
                                                {productcatogery.map((option) => (
                                                    option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                                                        {option.productCategoryName}
                                                    </MenuItem> : null
                                                ))}
                                            </TextField>
                                        </Grid>
                                        : null}
                                    {isActive == false ?
                                        <>
                                            <Grid item md={4} xs={12} >
                                                <Autocomplete fullWidth
                                                    key={isFarmerClear}
                                                    id="cropID"
                                                    options={product}
                                                    getOptionLabel={(option) => option.productName != null ? option.productName.toString() : null}
                                                    onChange={(e, value) => handleSearchCrop(value, e)}
                                                    defaultValue={null}
                                                    renderInput={(params) =>
                                                        <TextField {...params}
                                                            variant="outlined"
                                                            name="cropID"
                                                            label="Crop *"
                                                            size="small"
                                                            fullWidth
                                                            value={formik.values.cropID}
                                                            getOptionDisabled={true}
                                                            helperText={touched.cropID && errors.cropID}
                                                            error={Boolean(touched.cropID && errors.cropID)}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item md={4} xs={12} >
                                                <TextField
                                                    fullWidth
                                                    id="outlined-start-adornment"
                                                    size="small"
                                                    name='date'
                                                    label="Date *"
                                                    type="Date"
                                                    onKeyDown={onKeyDown}
                                                    value={formik.values.date}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('date')}
                                                    error={Boolean(touched.date && errors.date)}
                                                    helperText={touched.date && errors.date}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start"></InputAdornment>
                                                    }}
                                                    inputProps={{
                                                        min: new Date().toISOString().split('T')[0],
                                                    }}
                                                >
                                                </TextField>
                                            </Grid>
                                        </>
                                        : null}

                                    <Grid item md={4} xs={12} >
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                            <br />
                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color='secondary'
                                    onClick={() => {
                                        validateForm().then(errors => {
                                            setTouched(errors)
                                            setErrors(errors)
                                            if (Object.keys(errors).length === 0) {
                                                handleSave()
                                            }
                                        });
                                    }}

                                > Add</Button>
                            </Stack>
                            <br />
                        </Form>
                    </FormikProvider>
                    {cropForcaste.length != 0 ? <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TableContainer sx={{ maxHeight: 440 }}>
                                <Table size="small" border='1px' stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow sx={{ border: "2px solid black", backgroundColor: "#D1D9E6" }} >
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", fontWeight: "bold" }} align='center'>{isActive == true ? 'Collector' : 'Crop'}</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", fontWeight: "bold" }} align='center'>{isActive == true ? 'Crop' : 'Collector'}</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", fontWeight: "bold" }} align='center'>Variety</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", fontWeight: "bold" }} align='center'>Qty(Kg)</TableCell>
                                            <TableCell sx={{ backgroundColor: "#D1D9E6", fontWeight: "bold" }} align='center'>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ border: "2px solid black" }}>
                                        {cropForcaste.map((row) => (
                                            <TableRow key={row.cropForecastDetailID}>
                                                <TableCell align='left'>
                                                    {isActive == true ? row.farmerName : row.productName}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {isActive == true ? row.productName : row.farmerName}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.varietyName}
                                                </TableCell>
                                                <TableCell align='right' width={200}>
                                                    <TextField
                                                        size='small'
                                                        id="outlined-size-small"
                                                        onChange={(e) => changeText(e, row.cropForecastDetailID)}
                                                        value={row.quantity}
                                                        error={Boolean(row.quantityBit && row.quantityMsg)}
                                                        helperText={row.quantityBit && row.quantityMsg}
                                                        InputProps={{
                                                            inputProps: {
                                                                step: 0.01,
                                                                type: 'number',
                                                                style: {
                                                                    textAlign: 'right',
                                                                },
                                                            },
                                                        }}
                                                        onKeyDown={(evt) =>
                                                            (evt.key === "-") && evt.preventDefault()
                                                        }
                                                        onWheel={event => event.target.blur()}
                                                        textAlign='right'
                                                    />
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <Tooltip title="Remove Crop">
                                                        <IconButton aria-label="delete" onClick={() => collectorCropPopUp(row.cropForecastDetailID)}>
                                                            <Delete />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                        <br />
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color='secondary'
                                onClick={() => trackPromise(handleUpdate())}
                                disabled={IsUpdate == false}

                            > Update</Button>
                        </Stack>
                        <br />
                    </>
                        : <SearchNotFound searchQuery="Collector Crop Update" />}
                </Container>
            </Page>
            {dialogbox ?
                <AddEditTable
                    dialogbox={dialogbox}
                    setDialogbox={setDialogbox}
                    isActive={isActive}
                    details={values}
                    cropName={formData.cropName}
                />
                : null
            }
            <div hidden={true}>
                <Grid item>
                    <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                        discription={"Are you sure want to remove the collector crop ?"} setViewPopup={setEnableConfirmMessage} />
                </Grid>
            </div>
        </>
    );
}